<template>
    <v-dialog v-model="showReceipt"  width="420px" persistent attach="#app">
        <v-card dark
            :class="`!bg-transparent !backdrop-blur-md !border-2 p-4 font-Nunito  ${routeLink}-border !rounded-xl`">
            <div class="absolute right-3 top-3">
                <v-icon @click.prevent="$emit('closeReceipt')">mdi-window-close</v-icon>
            </div>
            <v-card-title :class="`!text-center font-Handel !uppercase font-bold ${routeLink}_fortext`">
                Receipt no. {{ receiptData.invoice_number }}
            </v-card-title>
            <v-list class="!bg-transparent !backdrop-blur-sm ">
                <v-list-item class="capitalize flex !justify-between !items-center" >
                    <div>date</div>
                    <div >{{receiptData.full_date }} </div>
                </v-list-item>
                <v-list-item class="capitalize flex !justify-between !items-center">
                    <div>order no.</div>
                    <div>{{ receiptData.invoice_number }}</div>
                </v-list-item>
                <v-list-item class="capitalize flex !justify-between !items-center">
                    <div>Payment Method</div>
                    <div v-if="receiptData.payment_method">Card( **** **** **** {{ receiptData.payment_method.card.last_four }} )</div>
                </v-list-item>
                <v-list-item class="capitalize flex !justify-between !items-center">
                    <div>Retailer</div>
                    <div> {{ receiptData.account_name }} </div>
                </v-list-item>
                <v-list-item class="capitalize flex !justify-between !items-center">
                    <div>product</div>
                    <div>{{ receiptData.plan_name }} Package</div>
                </v-list-item>
                <v-list-item class="capitalize flex !justify-between !items-center">
                    <div>total</div>
                    <div>$ {{ receiptData.amount }} </div>
                </v-list-item>
            </v-list>
        </v-card>
    </v-dialog>
</template>
<script>
import axios from 'axios'

export default {
    props: {
        showReceipt: Boolean,
        receiptData: Object,
    },
    data() {
        return {
            // showReceipt :false,
        }
    },
    methods: {
      
    },
    mounted() {
    },

}
</script>
<style scoped>
.straight-border {
    border-color: #a07a1d !important;
}

.gay-border {
    border-color: #88c3fa !important;
}

.lesbian-border {
    border-color: #9e2eec !important;
}
</style>